<template>
  <div>
    <v-container grid-list-md>
      <v-layout wrap>
        <v-flex xs12>
          <span class="font-weight-bold">Proposta</span>
        </v-flex>

        <v-flex xs12 sm6 md2>
          <v-select
            id="personTypeInput"
            label="Entidade*"
            ref="personType"
            v-model="person_type"
            :items="person_type_items"
            item-value="value"
            item-text="text"
            :rules="[(v) => !!v || 'Por favor, informe o tipo de pessoa']"
            required
            :readonly="!proposal_validation.can_subscription"
            :disabled="!proposal_validation.can_subscription || isCorreios"
            :selected="clearCpf"
          />
        </v-flex>
        <v-flex xs12 sm6 md2>
          <v-text-field
            id="cpfInput"
            :label="person_type === 'pf' ? 'CPF*' : 'CNPJ*'"
            v-model="cpf"
            @change="buscaDadosComplementares($event)"
            :mask="
              person_type === 'pf' ? '###.###.###-##' : '##.###.###/####-##'
            "
            :rules="
              person_type === 'pf'
                ? [
                    (v) => (v && v.length >= 11) || 'Preencha o CPF Completo',
                    (v) => this.validaCPF(v) === true || 'CPF inválido',
                  ]
                : [
                    (v) => (v && v.length == 14) || 'Preencha o CNPJ Completo',
                    (v) => this.validaCNPJ(v) === true || 'CNPJ inválido',
                  ]
            "
            required
            :append-icon="config.searchCemigUcs ? 'launch' : ''"
            @click:append="show_dialog_ucs"
            append-outer-icon="autorenew"
            @click:append-outer="buscaDadosComplementares(cpf)"
            :readonly="
              proposal_validation.cpf_valid &&
              !proposal_validation.can_subscription
            "
            :disabled="isCorreios"
          />
        </v-flex>
        <v-flex xs12 sm6 md3>
          <v-text-field
            id="emailInput"
            label="E-mail*"
            v-model="email"
            type="email"
            @change="buscaMember($event, 'email')"
            required
            :rules="[
              (v) => !!v || 'Por favor, informe o email',
              (v) =>
                /^(([^<>()\[\]\\.,;:\s@&quot;]+(\.[^<>()\[\]\\.,;:\s@&quot;]+)*)|(&quot;.+&quot;))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/.test(
                  v,
                ) || 'E-mail precisa ser válido',
            ]"
            append-icon="autorenew"
            @click:append="buscaMember(email, 'email')"
            append-outer-icon="close"
            @click:append-outer="clearForm"
            :readonly="!proposal_validation.can_subscription"
          />
        </v-flex>
        <v-flex xs12 sm6 md3>
          <v-text-field
            id="emailConfirmationInput"
            label="Confirme o e-mail*"
            v-model="emailConfirmation"
            type="email"
            required
            :rules="[
              (v) => !!v || 'Por favor, confirme o email',
              (v) =>
                v === email ||
                'E-mail não corresponde ao e-mail digitado anteriormente',
            ]"
            v-on:paste.prevent="$event"
            :readonly="!proposal_validation.can_subscription"
          />
        </v-flex>
        <v-flex xs12 sm6 md2>
          <v-select
            id="utilityCompanyInput"
            label="Concessionária*"
            v-model="utility_company"
            :items="utilityCompanies"
            item-value="id"
            item-text="name"
            :rules="[(v) => !!v || 'Por favor, informe a concessionária']"
            required
            :readonly="!proposal_validation.can_subscription"
            :disabled="!proposal_validation.can_subscription || isCorreios"
          />
        </v-flex>
        <v-flex
          xs12
          sm6
          :md3="person_type === 'pf'"
          :md4="person_type === 'pj'"
        >
          <v-text-field
            id="nameInput"
            :label="
              'Nome Completo' +
              (person_type === 'pj' ? ' do Representante Legal*' : '*')
            "
            v-model="name"
            @input="convertToTitleCase"
            @change="saveLead"
            :rules="nameRules"
            required
            :readonly="!proposal_validation.can_subscription"
            :disabled="!proposal_validation.can_subscription || isCorreios"
          />
        </v-flex>
        <v-flex xs12 sm6 md4 v-if="person_type === 'pj'">
          <v-text-field
            id="cpfLegalResponsibleInput"
            label="CPF do Representante Legal*"
            v-model="cpf_legal_responsible"
            :mask="'###.###.###-##'"
            :rules="[
              (v) => !!v || 'Por favor, informe o CPF do representante legal',
              (v) => (v && v.length == 11) || 'Preencha o CPF Completo',
              (v) => this.validaCPF(v) === true || 'CPF inválido',
            ]"
            required
            :readonly="!proposal_validation.can_subscription"
            :disabled="!proposal_validation.can_subscription || isCorreios"
            @change="saveLead"
          />
        </v-flex>
        <v-flex xs12 sm6 md4 v-if="person_type === 'pj'">
          <v-text-field
            id="companyNameInput"
            label="Razão Social*"
            v-model="company_name"
            :rules="[(v) => !!v || 'Por favor, informe a razão social']"
            required
            :readonly="!proposal_validation.can_subscription"
            :disabled="!proposal_validation.can_subscription || isCorreios"
            @change="saveLead"
          />
        </v-flex>
        <v-flex
          xs12
          sm6
          :md3="person_type === 'pf'"
          :md4="person_type === 'pj'"
        >
          <v-text-field
            id="phoneInput"
            label="Telefone*"
            v-model="phone"
            mask="(##)#####-####"
            :rules="[
              (v) => !!v || 'Por favor, informe o celular',
              (v) =>
                (v && v.length > 10) ||
                'Ops. Parece que esse não é um número de telefone',
            ]"
            required
            @change="saveLead"
            :readonly="!proposal_validation.can_subscription"
            :disabled="!proposal_validation.can_subscription || isCorreios"
          />
        </v-flex>
        <v-flex
          xs12
          sm6
          :md3="person_type === 'pf'"
          :md4="person_type === 'pj'"
        >
          <v-text-field
            id="couponInput"
            label="Cupom de Desconto"
            v-model="cupom"
            hint="Opcional"
            required
            :readonly="
              newCoupon.isValidCoupon || !proposal_validation.can_subscription
            "
            v-on:keyup.enter="addOrRemoveCoupon"
            :append-outer-icon="
              newCoupon.disabledCupom ? 'highlight_off' : 'verified'
            "
            @click:append-outer="addOrRemoveCoupon"
            :disabled="isCorreios"
          />
        </v-flex>
        <v-flex
          xs12
          sm6
          :md3="person_type === 'pf'"
          :md4="person_type === 'pj'"
        >
          <v-layout row>
            <v-select
              id="planInput"
              label="Plano*"
              v-model="plan"
              :items="plans"
              :item-text="formattedPlanText"
              item-value="id"
              return-object
              :rules="[(v) => !!v || 'Por favor, informe o plano do membro']"
              required
              :readonly="!proposal_validation.can_subscription"
              :disabled="!proposal_validation.can_subscription || isCorreios"
            />
            <div>
              <v-tooltip v-if="!haveUtilityCert" bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    color="#7d3dff"
                    round
                    fab
                    small
                    dark
                    @click="generateLink"
                    :disabled="isCorreios"
                  >
                    <v-icon>link</v-icon>
                  </v-btn>
                </template>
                <span>Gerar link para conexão com concessionária</span>
              </v-tooltip>

              <v-tooltip v-else bottom>
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on" flat icon>
                    <v-icon color="green">check</v-icon>
                  </v-btn>
                </template>
                <span>Dados da concessionária foram preenchidos</span>
              </v-tooltip>
            </div>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>

    <v-dialog v-model="loadingDialog" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          {{ labelLoading }}
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_ucs" persistent max-width="500px">
      <v-card class="pa-3">
        <v-card-title class="pa-0 pt-2">
          <span class="title font-weight-bold mx-auto"
            >Unidades Consumidoras do Cliente na Cemig</span
          >
        </v-card-title>
        <v-card-text class="pt-1 pb-3 px-0">
          <v-list subheader three-line>
            <v-subheader
              >Selecione as unidades consumidoras que o membro quer
              contratar.</v-subheader
            >
            <v-list-tile
              v-for="(uc, idx) in ucs_cemig"
              :key="uc.installation_number"
            >
              <v-list-tile-action>
                <v-checkbox
                  v-model="ucs_checkbox"
                  :value="idx"
                  :color="colors[idx]"
                ></v-checkbox>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>{{
                  uc.installation_number
                }}</v-list-tile-title>
                <v-list-tile-sub-title>{{ uc.address }}</v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-card-text>
        <v-card-actions>
          <div class="mx-auto">
            <v-btn
              color="primary"
              text
              :disabled="loading_qualification"
              @click="dialog_ucs = false"
              >Fechar</v-btn
            >
            <v-btn
              color="pink darken-1"
              text
              :loading="loading_qualification"
              :disabled="ucs_checkbox?.length == 0 || !ucs_checkbox"
              @click="ucs_selected()"
              >Selecionar</v-btn
            >
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="disableToSellDialogOpen" max-width="300px">
      <v-card>
        <v-card-title>
          <h3>Lembrete</h3>
          <v-spacer></v-spacer>
          <v-btn flat icon @click="disableToSellDialogOpen = false">
            <v-icon color="red">close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-container fluid class="pa-0">
            <v-layout row wrap>
              <v-flex xs12>
                <div v-html="disabledSellMessage"></div>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-snackbar
      :color="snackBar.color"
      :bottom="snackBar.bottom"
      :top="snackBar.top"
      :left="snackBar.left"
      :right="snackBar.right"
      multi-line
      v-model="snackBar.snackbar"
      dark
    >
      <v-icon color="white" class="mr-3">mdi-bell-plus</v-icon>
      <div v-html="snackBar.snackMessage"></div>
      <v-icon size="16" @click="snackBar.snackbar = false"
        >mdi-close-circle</v-icon
      >
    </v-snackbar>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import firestore from "../../../firebase/firestore";
import { getCPFCemig } from "../../../services/getCPFCemig";
import { addLead } from "../../../services/leads";
import { initQualification } from "../../../services/qualification";
import {
  validaCNPJ,
  validaCPF,
  validaCPFNaBase,
} from "../../../services/users";
import { formatPhone, reversePhone } from "../../../utils/utils";

export default {
  name: "ProposalForm",

  mounted() {
    this.$refs.personType.focus();
    this.agent_email = this.loggedUser.email || null;

    this.getUtilityCompanies({ origin: "super", onlyActivated: true });
    if (this.plans?.length <= 0) {
      let available_plans = this.filteredPlans({
        person_type: this.person_type,
        company: "juntos",
        utility_company: this.utility_company,
      });
      if (this.loggedUser) {
        if (this.loggedUser.group) {
          if (
            this.loggedUser.group.includes("sales_partner") ||
            this.loggedUser.group.includes("sales_partner_management")
          ) {
            available_plans = available_plans.filter(
              (plan) => plan.promotional === false,
            );
          }
        }
      }
      this.plans = available_plans;
      if (this.plans?.length === 1) this.plan = this.plans[0];
    }
    if (this.cpf) {
      this.buscaDadosComplementares(this.cpf);
    }
  },

  data: () => ({
    couponUpdate: 0,
    colors: ["green", "purple", "indigo", "cyan", "teal", "orange"],
    dialog_ucs: false,
    installation_numbers: [],
    haveUtilityCert: false,
    labelLoading: "",
    loadingDialog: false,
    loading_qualification: false,
    newCoupon: {
      couponMessage: "",
      isValidCoupon: false,
      loadingCupom: false,
      disabledCupom: false,
    },
    person_type_items: [
      { text: "Pessoa Física", value: "pf" },
      { text: "Pessoa Jurídica", value: "pj" },
    ],
    plans: [],
    qualification_ids: [],
    snackBar: {
      snackbar: false,
      snackMessage: "",
      color: "",
      top: true,
      bottom: false,
      left: false,
      right: false,
    },
    ucs: [],
    ucs_checkbox: [],
    ucs_cemig: [],
    valid: false,
    nameRules: [
      (v) => !!v || "Por favor, informe o seu nome completo.",
      (v) => /.*\s.*/.test(v?.trim()) || "Informe o nome completo.",
      (v) => !v?.match(/\d/g) || "Não pode conter número.",
    ],
    agent_email: null,
    emailConfirmation: "",
    disableToSellDialogOpen: false,
    canSell: true,
  }),

  computed: {
    ...mapGetters("sales", ["filteredPlans"]),
    ...mapGetters(["loggedUser"]),
    ...mapState("configuration", ["loading", "utilityCompanies"]),
    ...mapState("sales", ["user", "proposal_validation", "lead", "isCorreios"]),
    ...mapState("qualification", ["qualifications"]),
    ...mapState(["config"]),

    email: {
      get() {
        return this.$store.state.sales.user?.email;
      },
      set(value) {
        this.$store.commit("sales/setEmail", value?.trim());
      },
    },
    utility_company: {
      get() {
        return this.$store.state.sales.user?.utility_company;
      },
      set(value) {
        this.$store.commit("sales/setUtilityCompany", value);
      },
    },
    person_type: {
      get() {
        return this.$store.state.sales.user?.person_type;
      },
      set(value) {
        this.$store.commit("sales/setPersonType", value);
      },
    },
    cpf: {
      get() {
        return this.$store.state.sales.user?.cpf;
      },
      set(value) {
        this.$store.commit("sales/setCPF", value);
      },
    },
    name: {
      get() {
        return this.$store.state.sales.user?.name;
      },
      set(value) {
        this.$store.commit("sales/setName", value?.trim());
      },
    },
    phone: {
      get() {
        return reversePhone(this.$store.state.sales.user?.phone);
      },
      set(value) {
        this.$store.commit("sales/setPhone", formatPhone(value, "+55"));
      },
    },
    cupom: {
      get() {
        this.couponUpdate;
        return this.$store.state.sales.user?.coupon;
      },
      set(value) {
        this.$store.commit("sales/setCupom", value?.trim());
      },
    },
    plan: {
      get() {
        return this.$store.state.sales.plan;
      },
      set(value) {
        this.$store.commit("sales/setPlan", value);
      },
    },
    cpf_legal_responsible: {
      get() {
        return this.$store.state.sales.user?.cpf_legal_responsible || null;
      },
      set(value) {
        this.$store.commit("sales/setCpfLegalResponsible", value?.trim());
      },
    },
    company_name: {
      get() {
        return this.$store.state.sales.user?.company_name || null;
      },
      set(value) {
        this.$store.commit("sales/setCompanyName", value?.trim());
      },
    },

    disabledSellMessage() {
      if (!this.utility_company) return null;
      const uc = this.utilityCompanies.find(
        (item) => item.id === this.utility_company,
      );
      return uc ? uc.enabled_to_sell_msg : "";
    },
  },

  watch: {
    person_type() {
      let available_plans = this.filteredPlans({
        person_type: this.person_type,
        company: "juntos",
        utility_company: this.utility_company,
      });
      if (this.loggedUser) {
        if (this.loggedUser.group) {
          if (
            this.loggedUser.group.includes("sales_partner") ||
            this.loggedUser.group.includes("sales_partner_management")
          ) {
            available_plans = available_plans.filter(
              (plan) => plan.promotional === false,
            );
          }
        }
      }
      this.plans = available_plans;
    },

    utility_company() {
      let available_plans = this.filteredPlans({
        person_type: this.person_type,
        company: "juntos",
        utility_company: this.utility_company,
      });
      if (this.loggedUser) {
        if (this.loggedUser.group) {
          if (
            this.loggedUser.group.includes("sales_partner") ||
            this.loggedUser.group.includes("sales_partner_management")
          ) {
            available_plans = available_plans.filter(
              (plan) => plan.promotional === false,
            );
          }
        }
      }
      this.plans = available_plans;

      const utilityCompanyData = this.utilityCompanies.find(
        (item) => item.id === this.utility_company,
      );

      if (utilityCompanyData?.enabled_to_sell) {
        this.canSell = true;
        this.$emit("disableSell", false);
      } else {
        this.canSell = false;
        this.disableToSellDialogOpen = true;
        this.$emit("disableSell", true);
      }
    },

    plans() {
      if (this.plans?.length === 1) this.plan = this.plans[0];
      this.$emit("showUcsList", this.plans);
    },

    lead() {
      this.haveUtilityCert = !!this.lead?.utility_cert;
    },
  },

  methods: {
    ...mapActions("qualification", ["getQualifications"]),
    ...mapActions("sales", [
      "getCoupons",
      "getPlansByParams",
      "getMember",
      "getLeadByEmail",
    ]),
    ...mapActions("configuration", ["getUtilityCompanies"]),
    ...mapMutations("sales", [
      "setUser",
      "setProposalValidation",
      "resetOtherState",
      "setIsCorreios",
    ]),
    ...mapMutations("qualification", ["setQualifications"]),

    convertToTitleCase() {
      const prepositions = ["de", "da", "das", "do", "dos", "e"];
      this.name = this.name
        .toLowerCase()
        .replace(/\b[^ \t\n\r\f\v]+/g, (word) => {
          const lowerCasedWord = word.toLowerCase();
          return prepositions.includes(lowerCasedWord)
            ? lowerCasedWord
            : this.capitalize(word);
        });
    },

    capitalize(word) {
      return word.charAt(0).toUpperCase() + word.slice(1);
    },

    setName() {
      this.$store.commit("sales/setName", this.name);
    },

    lowercase() {
      this.email = this.user?.email?.toLowerCase();
    },

    clearForm() {
      this.setIsCorreios(false);
      this.$emit("clearForm");
    },

    snack(message, color, ...args) {
      this.snackBar.top = true;
      this.snackBar.bottom = false;
      this.snackBar.left = false;
      this.snackBar.right = false;

      for (const loc of args) {
        this[loc] = true;
      }

      this.snackBar.color = color;
      this.snackBar.snackMessage = message;
      this.snackBar.snackbar = true;
    },

    async buscaMember(param, type) {
      this.setIsCorreios(false);
      if (!param) return;
      if (type === "email") param.toLowerCase();
      this.loadingDialog = true;
      this.labelLoading = "Verificando se " + type + " já está cadastrado...";
      this.$store.commit("qualification/setQualifications", []);
      let member = await this.getMember({ value: param, type });

      if (!member) {
        this.loadingDialog = false;
        this.labelLoading = "";
        return;
      }

      // Se o membro já existe, preenche o campo de confirmação de email
      if (member?.email) this.emailConfirmation = member.email;

      // Verifica se o membro foi vendido pelos Correios
      if (member?.signedcontract_by === "Correios") {
        this.snack(
          "Realize a qualificação pela tela 'Editar membro e UC'",
          "warning",
          "bottom",
        );
        this.loadingDialog = false;
        this.setIsCorreios(true);
        return;
      }

      if (member?.cpf) {
        this.labelLoading = "Verificando se CPF já está cadastrado...";
        const {
          cpf_valid,
          cpf_duplicated,
          email_found,
          same_email,
          can_subscription,
          financial_pending,
          ucs,
        } = await validaCPFNaBase(
          member.cpf,
          this.person_type,
          this.email,
          member,
          true,
        );

        const cpfObj = {
          cpf_valid,
          cpf_duplicated,
          email_found,
          same_email,
          can_subscription,
          financial_pending,
          ucs,
        };
        this.setProposalValidation(cpfObj);

        if (this.user?.qualification_ids) {
          const qualificationObj = {
            cpf: member.cpf,
            qualification_ids: this.user.qualification_ids,
          };
          this.getQualifications(qualificationObj);
        }

        if (this.user?.plan?.id) {
          const user_plan = this.user.plan;
          if (!user_plan.person_type) {
            const localPlan = this.plans.find(
              (item) => item.id == user_plan.id,
            );
            user_plan.person_type = localPlan?.person_type;
          }
          if (!this.plans.find((item) => item.id == user_plan.id)) {
            this.plans.push(user_plan);
          }
          this.plan = user_plan;
        } else {
          let available_plans = this.filteredPlans({
            person_type: this.person_type,
            utility_company: this.utility_company,
            company: "juntos",
          });
          if (this.loggedUser) {
            if (this.loggedUser.group) {
              if (
                this.loggedUser.group.includes("sales_partner") ||
                this.loggedUser.group.includes("sales_partner_management")
              ) {
                available_plans = available_plans.filter(
                  (plan) => plan.promotional === false,
                );
              }
            }
          }
          this.plans = available_plans;
        }
        this.name = this.user?.name ?? "";
        this.nameFixed = this.name;

        this.setLead();
      }
      this.loadingDialog = false;
      this.labelLoading = "";
    },

    show_dialog_ucs() {
      if (!this.config.searchCemigUcs)
        this.snack(
          "Função desabilitada pois a concessionária está fora do ar",
          "warning",
          "bottom",
        );
      else if (this.utility_company === "cemig") {
        this.dialog_ucs = this.ucs_cemig.length ? true : false;
      } else {
        this.snack(
          "Essa funcionalidade só existe para clientes CEMIG no momento",
          "error",
          "bottom",
        );
      }
    },

    async buscaDadosComplementares(cpf) {
      if (!cpf) return;
      this.loadingDialog = true;
      this.labelLoading = "Verificando se CPF já está cadastrado...";
      const {
        cpf_valid,
        cpf_duplicated,
        email_found,
        same_email,
        can_subscription,
        financial_pending,
        ucs,
      } = await validaCPFNaBase(
        cpf,
        this.person_type,
        this.email,
        this.user,
        true,
      );

      const cpfObj = {
        cpf_valid,
        cpf_duplicated,
        email_found,
        same_email,
        can_subscription,
        financial_pending,
        ucs,
      };
      this.setProposalValidation(cpfObj);

      // Verifica se o membro foi vendido pelos Correios
      if (this.user?.signedcontract_by === "Correios") {
        this.snack(
          "Realize a qualificação pela tela 'Editar membro e UC'",
          "warning",
          "bottom",
        );
        this.loadingDialog = false;
        this.setIsCorreios(true);
        return;
      }

      if (
        this.config.searchCemigUcs &&
        this.utility_company === "cemig" &&
        cpf != ""
      ) {
        this.labelLoading = "Buscando dados do membro na CEMIG...";
        await getCPFCemig(cpf)
          .then((ret) => {
            if (ret.status === 200) {
              this.ucs_cemig = ret.data;
              ret.data.forEach((data, idx) => {
                const item_uc = {
                  text: data.installation_number,
                  color: this.colors[idx],
                };
                this.installation_numbers.push(item_uc);
              });
              if (this?.qualifications[0]?.cpf != this.cpf) {
                this.setQualifications([]);
              }
              this.name = this.ucs_cemig[0].name;
              this.loadingDialog = false;
              this.dialog_ucs = true;
            }
          })
          .catch((err) => {
            console.error(err);
            this.snack(
              `Erro ao buscar dados na CEMIG. ${
                err?.response ? err.response.data : ""
              }`,
              "warning",
              "bottom",
            );
            this.ucs_cemig = [];
            this.loadingDialog = false;
            this.$emit("showUcsList", this.plans);
          });
      } else {
        this.loadingDialog = false;
        this.$emit("showUcsList", this.plans);
      }
    },

    async ucs_selected() {
      this.loading_qualification = true;
      const ucs = this.ucs_checkbox.map((index) => this.ucs_cemig[index]);
      const installationNumbers = ucs?.map((uc) => uc.installation_number);
      for (const uc of ucs) {
        const ucFound = (
          await firestore
            .collection("consumer_units")
            .doc(uc.installation_number)
            .get()
        )?.data();

        const statusAllowedToSell = [
          "activated",
          "awaiting_signature",
          "awaiting_contract_generation",
          "canceling",
          "interrupting",
          "interrupted",
        ];

        const uc_status = {
          activated: "Ativo",
          awaiting_signature: "Aguardando assinatura de contrato",
          awaiting_contract_generation: "Aguardando geração de contrato",
          canceling: "Em cancelamento",
          interrupting: "Interrompendo fornecimento",
          interrupted: "Fornecimento interrompido",
        };

        if (statusAllowedToSell.includes(ucFound?.status)) {
          const text = `A UC ${uc.installation_number} já existe com status ${
            uc_status[ucFound.status]
          }.`;
          this.errorOnInitQualification(text, "error");
          return;
        }

        const qualificationFound = this.qualifications.some(
          (item) => item.consumer_unit == uc.installation_number,
        );
        if (qualificationFound) {
          const text = `A UC ${uc.installation_number} já foi adicionada a lista de qualificação.`;
          this.errorOnInitQualification(text, "warning");
          return;
        }
      }
      await initQualification(
        this.cpf,
        null,
        installationNumbers,
        "inside_sales",
        false,
        null,
        this.utility_company,
        ucs,
        this.agent_email,
      )
        .then((ret) => {
          if (ret.status === 200) {
            this.qualification_ids = ret.data.ids;
            const params = {
              cpf: this.cpf,
              qualification_ids: this.qualification_ids,
            };
            this.getQualifications(params);
          }
        })
        .catch((err) => {
          console.error(err);
          this.snack(
            `Erro ao iniciar qualificação. ${
              err?.response ? err.response.data : ""
            }`,
            "warning",
            "bottom",
          );
          this.$emit("showUcsList", this.plans);
        });
      this.loading_qualification = false;
      this.ucs_checkbox.map((sel, index) => {
        const obj = {
          text: sel,
          color: this.colors[index],
        };
        this.ucs.push(obj);
      });
      this.ucs_checkbox = [];
      this.dialog_ucs = false;
      this.$emit("showUcsList", this.plans);
    },

    errorOnInitQualification(text, type) {
      this.loading_qualification = false;
      this.dialog_ucs = false;
      this.ucs_checkbox = [];
      this.snack(text, type, "top");
    },

    formattedPlanText(item) {
      const person_type = item.person_type
        ? item.person_type.toUpperCase()
        : "";
      return item.name + " " + person_type + " - " + item.discount + "%";
    },

    call(phone) {
      const newPhone = formatPhone(phone, "+55").split("+55")[1];
      window.open("tel:" + newPhone, "_self");
    },

    upperCaseCoupon() {
      this.newCoupon.cupom = this.newCoupon?.cupom?.toUpperCase();
    },

    clearCoupon() {
      this.cupom = "";
      this.newCoupon.couponMessage = null;
      this.newCoupon.disabledCupom = false;
      this.newCoupon.isValidCoupon = false;
      let available_plans = this.filteredPlans({
        person_type: this.person_type,
        company: "juntos",
        utility_company: this.utility_company,
      });
      if (this.loggedUser) {
        if (this.loggedUser.group) {
          if (
            this.loggedUser.group.includes("sales_partner") ||
            this.loggedUser.group.includes("sales_partner_management")
          ) {
            available_plans = available_plans.filter(
              (plan) => plan.promotional === false,
            );
          }
        }
      }
      this.plans = available_plans;
      this.couponUpdate++;
    },

    clearCpf() {
      this.cpf = "";
      this.clearCoupon();
    },

    addOrRemoveCoupon() {
      if (!this.newCoupon.disabledCupom) this.validateCoupon();
      else this.clearCoupon();
    },

    validateCoupon() {
      const cupom = this.$store.state.sales.user?.coupon;
      this.newCoupon.loadingCupom = true;
      if (!cupom || cupom?.trim() === "") {
        this.newCoupon.loadingCupom = false;
        this.newCoupon.isValidCoupon = false;
        this.clearCoupon();
      }
      return this.getCoupons(cupom)
        .then((res) => {
          if (res?.status && this.$store.state.sales.coupon?.plan_id) {
            const plan = this.filteredPlans({
              plan_id:
                this.$store.state.sales.coupon.plan_id + this.person_type,
            });
            if (!this.plans.includes(plan[0])) {
              this.plans.push(plan[0]);
            }
            this.plan = plan[0];
          }
          if (res.message === "Ok") {
            this.newCoupon.disabledCupom = true;
            this.newCoupon.isValidCoupon = true;
          }
          this.newCoupon.couponMessage =
            res.message === "Ok" ? "Cupom aplicado com sucesso!" : res.message;
          this.snack(
            this.newCoupon.couponMessage,
            res.message === "Ok" ? "green" : "red",
            "top",
          );
          this.newCoupon.loadingCupom = false;
          this.couponUpdate++;
        })
        .catch((err) => {
          console.error(err);
          this.newCoupon.isValidCoupon = false;
          this.newCoupon.couponMessage = err.message;
          this.snack("Cupom inválido.", "red", "top");
          this.newCoupon.loadingCupom = false;
          this.valid = false;
          this.clearCoupon();
        });
    },

    validaCPF(cpf) {
      return validaCPF(cpf);
    },

    validaCNPJ(cnpj) {
      return validaCNPJ(cnpj);
    },

    saveLead() {
      this.setName();
      if (
        this.user?.email &&
        this.user?.email !== "" &&
        this.user?.utility_company &&
        this.user?.utility_company !== "" &&
        this.user?.person_type &&
        this.user?.person_type !== "" &&
        this.user?.name &&
        this.user?.name !== "" &&
        this.user?.phone &&
        this.user?.phone !== "" &&
        this.proposal_validation.can_subscription
      ) {
        addLead(this.user);
        return true;
      } else {
        return false;
      }
    },

    async setLead() {
      await this.getLeadByEmail(this.user?.email);
    },

    generateLink() {
      if (this.saveLead()) {
        const link = `https://juntos.eco/portal?lead=${this.user?.email}&utility=${this.user?.utility_company}`;
        navigator.clipboard.writeText(link);
        this.snack(
          "Link gerado e copiado para área de transferência.",
          "green",
          "top",
        );
        this.setLead();
        this.lead.generated_link = true;
        const generated_link = this.lead?.generated_link ?? 0;
        const lead = {
          email: this.lead.email,
          generated_link: generated_link + 1,
        };
        addLead(lead);
      } else {
        this.snack("Preencha todos os campos obrigatórios.", "red", "top");
      }
    },
  },
};
</script>
